import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../lib/auth'

export default function AuthCallback() {
  const navigate = useNavigate()
  const { user, profile, loading } = useAuthStore()

  useEffect(() => {
    if (loading) return

    if (!user) {
      navigate('/login', { replace: true })
      return
    }

    if (profile) {
      // Existing user — go to dashboard
      navigate('/dashboard', { replace: true })
    } else {
      // New OAuth user — needs to pick a plan before profile is created
      localStorage.setItem('oauth_new_user', 'true')
      navigate('/plans', { replace: true })
    }
  }, [user, profile, loading, navigate])

  return (
    <div className="min-h-screen bg-[#0a0e17] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <svg className="w-10 h-10 text-cyan-400 animate-spin" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z" />
        </svg>
        <p className="text-gray-400 text-sm">Signing you in…</p>
      </div>
    </div>
  )
}
